module.exports = __webpack_public_path__ + "img/Path 17 Copy@3x.5fda384a.png";